import { ViewEncapsulation, Component, OnDestroy, OnInit, NgModule } from '@angular/core';
import { VisNetworkService, Data, Node, Options, Edge } from 'ngx-vis';
import { DataSet } from 'vis-data/peer/umd/vis-data';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Group } from '../data-abstraction/group';

@Component({
  selector: 'app-sociogram',
  templateUrl: './sociogram.component.html',
  styleUrls: ['./sociogram.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SociogramComponent implements  OnInit, OnDestroy {
  public disabled = false;
  public checked = false;
  public visNetwork: string = 'networkId1';
  public visNetworkData: Data;
  public nodes: DataSet<Node>;
  public edges: DataSet<Edge>;
  public visNetworkOptions: Options;
  public pGroup: Group;
  autoRenew = true;

  public constructor(private visNetworkService: VisNetworkService) {}

  public networkInitialized(): void {
    // now we can use the service to register on events
    // this.visNetworkService.on(this.visNetwork, 'click');
    this.visNetworkService.on(this.visNetwork, 'dragEnd');

    this.visNetworkService.dragEnd.subscribe((eventData: any[]) => {
      const pos = this.visNetworkService.storePositions(this.visNetwork);
      const nodePositions = this.nodes.map(({ id, x, y }) => ({ id, x, y }));
      localStorage.setItem('buho_positions', JSON.stringify(nodePositions));
      this.visNetworkService.fit(this.visNetwork);
    });

    const positions = localStorage.getItem("buho_positions");
    if (positions != null) {
      const nodePositions = JSON.parse(positions);
      nodePositions.forEach( nodePosition => this.nodes.update(nodePosition) );
    }

    this.visNetworkService.fit(this.visNetwork);
  }

  public ngOnInit(): void {
    const buhoData = localStorage.getItem('buho_data');

    if (buhoData !== undefined) {
      this.pGroup = new Group('', '');
      this.pGroup.deserialize(buhoData);

      document.getElementById("meas-question").innerHTML = "Klass " + this.pGroup.group_name + " : " + this.pGroup.question;

      this.nodes = this.pGroup.all_students_node_data;

      this.edges = this.pGroup.all_relations_edge_data;

      this.visNetworkData = { nodes: this.nodes, edges: this.edges };

      this.visNetworkOptions = {
        physics: {
          enabled: false
        },
        edges: {
          smooth: {
            enabled: false,
            type: 'dynamic',
            roundness: 0.5,
            forceDirection: false
          }
        },
        nodes: {
          shape: "dot",
          scaling: {
            label: {
              min: 8,
              max: 20,
          },
        },
      }};
    }
  }

  public ngOnDestroy(): void {
    this.visNetworkService.off(this.visNetwork, 'click');
  }

  onChange(ob: MatSlideToggleChange): void {
    console.log(ob.checked);
    let matSlideToggle: MatSlideToggle = ob.source;
    console.log(matSlideToggle.id);

    if (matSlideToggle.id === 'toggle_match') {
      if (ob.checked) {
        console.log('Update: ' + this.pGroup.matching_relations);
        this.pGroup.matching_relations.forEach(item => this.edges.add(item));
      } else {
        console.log('Remove: ' + this.pGroup.matching_relations_ids);
        this.edges.remove(this.pGroup.matching_relations_ids);
      }
    }

    if (matSlideToggle.id === 'toggle_single') {
      if (ob.checked) {
        console.log('Update: ' + this.pGroup.single_relations);
        this.pGroup.single_relations.forEach(item => this.edges.add(item));
      } else {
        console.log('Remove: ' + this.pGroup.single_relations_ids);
        this.edges.remove(this.pGroup.single_relations_ids);
      }
    }
  }

  printElem(): void {
    const mywindow = window.open('', 'PRINT', 'height=750,width=1000');

    mywindow.document.write('<html><head><title>' + document.title  + '</title>');
    mywindow.document.write('</head><body >');
    mywindow.document.write('<h1>' + document.title  + '</h1>');
    mywindow.document.write(document.getElementById("sociogram").innerHTML);
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();
  }
}
